<template>
  <div>
    <van-cell v-for="(item,index) in list" :key="index" @click="toDetails(item)">
      <div class="flex-between">
        <div>
          <div class="custName-wrap">
            <div class="custName">
              {{ item.custName }}
            </div>
          </div>
          <div>
            <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.areaName">{{ item.areaName }}</van-tag>
            <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.industryName">{{ item.industryName }}</van-tag>
            <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.washResult">{{ washResultFormat(item.washResult) }}</van-tag>
          </div>
          <div>
            <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.fuSalesName">跟进销售：{{ item.fuSalesName }}</van-tag>
            <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.createTime">创建时间：{{ item.createTime | timeFormat }}</van-tag>
          </div>
        </div>
        <van-icon name="arrow" size="16" class="arrow-color" />
      </div>
    </van-cell>
  </div>
</template>

<script>
import moment from "moment";
import { Cell, Tag, Button, Icon, } from 'vant'
export default {
  name: 'ListItem',
  components: {
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  data() {
    return {
      list: this.listData,
      washResultOptions:[]
    }
  },
  watch: {
    listData: function (newVal, oldVal) {
      this.list = newVal
    }
  },
  props: ['listData'],
  created() {
    //清洗结果
    this.getDicts("crm_cust_wash_result").then((response) => {
      this.washResultOptions = response.data;
    });
  },
  filters: {
    timeFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  methods: {
    toDetails(item) {
      this.$emit('todetail', item)
    },
    //获取清洗结果
    washResultFormat(val) {
      return this.selectDictLabel(this.washResultOptions, val);
    },
  },
}
</script>